import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumbs, Grid } from "@material-ui/core";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import Search from "@material-ui/icons/Search";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import { Buscador } from "../afiliaciones/Buscador";
// import { fetchLocalidades } from "../../actions/cbos/localidades";
// import { fetchPlanes } from "../../actions/cbos/planes";
// import { desSeleccionarAfiliado, desSeleccionarAfiliadoConsulta } from "../../actions/afiliado";
import { changeStepper } from "../../actions/preAfiliado/stepper";
// import { IngresoTurnos } from "./nuevo/IngresoTurnos";
// import { ListaTurnos } from "./consultaTurnos/ListaTurnos";
// import { RecepcionDiaria } from "./recepcionDiaria/RecepcionDiaria";
// import { HomeCambiosEnAgenda } from "./cambiosAgenda/HomeCambiosEnAgenda";
import {
  FACTURACION_PERMISOS,
} from "../../utils/permisos";
import { BreadcrumbsItemsCustom } from "../BreadcrumbsItemsCustom";
import { GeneracionFacturas } from "./generacion/GeneracionFacturas";
import { ConsultaCtaCte } from "./consultaCtaCte/ConsultaCtaCte";
import { desSeleccionarAfiliadoConsulta } from "../../actions/afiliado";
import { FormFacturasGeneradas } from "./FacturasGeneradas/FormFacturasGeneradas";
// import { BajaMasiva } from "./bajaMasiva/BajaMasiva";
// import { ConsultaProfesional } from "./consultaProfesional/ConsultaProfesional";
// import { HomeConsultaBajas } from "./consultaBajas/HomeConsultaBajas";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "98%",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  colorSeleccionado: theme.palette.text.primary,
  colorDeseleccionado: theme.palette.text.secondary,
}));

export const HomeFacturacion = () => {
  const classes = useStyles();
  const { seleccionadoConsulta } = useSelector((state) => state.afiliacion);

  const [menu, setMenu] = useState(0);
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);

  const buttons = [
    {
      permiso: FACTURACION_PERMISOS.ALTA,
      validarAlgunPermiso: [],
      color: menu === 1 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: "btnGeneracion",
      text: "Generación",
      icon: LibraryBooksIcon,
    },
    {
      permiso: FACTURACION_PERMISOS.CONSULTA,
      validarAlgunPermiso: [],
      color: menu === 2 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: "btnConsulta",
      text: "Consulta Cta Cte",
      icon: Search,
    },
    {
      permiso: FACTURACION_PERMISOS.CONSULTA,
      validarAlgunPermiso: [],
      color: menu === 3 ? "secondary" : "inherit",
      classIcon: classes.icon,
      name: "btnFacturasGeneradas",
      text: "Facturas Generadas",
      icon: LocalAtmIcon,
    },
    // {
    //   permiso: CONFIGURACIONTURNOS_PERMISOS.GENERACION_ADMIN,
    //   validarAlgunPermiso: [],
    //   color: menu === 3 ? "secondary" : "inherit",
    //   classIcon: classes.icon,
    //   name: 'btnSubirCobranza',
    //   text: 'Subir Archivo Cobranza',
    //   icon: InsertDriveFileIcon,
    // },
    // {
    //   permiso: FACTURACION_PERMISOS.CONSULTA,
    //   color: menu === 4 ? "secondary" : "inherit",
    //   classIcon: classes.icon,
    //   name: 'btnConsultaProfesional',
    //   text: 'Consulta Por Profesional',
    //   icon: Search,
    // },
  ];

  //   const [checkingData, setCheckingData] = useState(true);

  const dispatch = useDispatch();

  //   useEffect(() => {
  //     if (!listaPlanesCargada) {
  //       dispatch(fetchPlanes());
  //     }
  //     setCheckingData(false);
  //   }, [dispatch, listaPlanesCargada]);

  //   useEffect(() => {
  //     if (!listaLocCargada) {
  //       dispatch(fetchLocalidades());
  //     }
  //     setCheckingData(false);
  //   }, [dispatch, listaLocCargada]);

  //****************************************** */
  const handleClick = (e) => {
    e.preventDefault();
    switch (e.currentTarget.name) {
      case "btnGeneracion":
        dispatch(changeStepper(0));
        setMostrar1(true);
        setMenu(1);
        break;
      case "btnConsulta":
        dispatch(desSeleccionarAfiliadoConsulta());
        setMostrar2(true);
        setMenu(2);
        break;
      case "btnFacturasGeneradas":
        setMostrar3(true);
        setMenu(3);
        break;
      case "btnBaja":
        setMostrar4(true);
        setMenu(4);
        break;
      default:
        break;
    }
  };

  //   if (checkingData) {
  //     return <h1>Cargando....</h1>;
  //   }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} styles={{ padding: 5 }}>
            <Breadcrumbs style={{ color: "#FAFAFA" }} aria-label="breadcrumb">
              <BreadcrumbsItemsCustom
                buttons={buttons}
                handleClick={handleClick}
              />
            </Breadcrumbs>
          </Grid>
          {mostrar1 && menu === 1 && <GeneracionFacturas />}

          {mostrar2 && menu === 2 && (
            <Grid item xs={12} sm={4} md={6} style={{ marginTop: -15 }}>
              <Buscador idConsulta={"idConsulta"} />
            </Grid>
          )}
          {seleccionadoConsulta && menu === 2 && (
            <Grid container justify="center">
              <ConsultaCtaCte />
            </Grid>
          )}

          {mostrar3 && menu === 3 && (
            <Grid item style={{ marginTop: "2rem" }}>
              <FormFacturasGeneradas />
            </Grid>
          )}

          {mostrar4 && menu === 4 && <h1>Btn4</h1>}
        </Grid>
      </div>
    </>
  );
};
